import { useQuery } from 'react-query';
import { fetchTvOnTheAir } from '../services/api';

export const useTvOnTheAir = options => {
  return useQuery('tvOnTheAir', fetchTvOnTheAir, options);
};
